import { MobileLoginModalComponent } from "./../mobile-login-modal/mobile-login-modal.component";

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {LoginProviderModal} from "./login-provider.component";

export function ShowLoginProviderModal(
    modalService: NgbModal,
    loginError: boolean = false,
    cookieLogin: string,
    mobileMode = "desktop",
    userName:string,
    userPassword:string | null,
    canAdd:boolean,
    canUpdate:boolean
): Promise<any> {
    const mobile = mobileMode != "desktop";
    const component = mobile ? LoginProviderModal : LoginProviderModal;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        backdropClass:"blurak",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    let modal = <LoginProviderModal>m.componentInstance;
    modal.loginError = loginError;
    modal.userName = userName;
    modal.userPassword = userPassword;
    modal.canAdd = canAdd;
    modal.canUpdate = canUpdate;
    console.log("SHOWLOGIN");
    console.log(cookieLogin);
    return m.result;
}
